import { Navigate, useLocation } from "react-router-dom";

// `/dashboard/director` e o antigo `/dashboard/director/owner` abrem o Dashboard da diretoria,
// preservando `?company_id=`.
const OwnerRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/dashboard/director/dashboard${search || ""}`} replace />;
};

export default OwnerRedirect;
